// extracted by mini-css-extract-plugin
module.exports = {"box":"box__1u9pn","vertical":"vertical__1ItZZ","contain":"contain__1HkqX"};